import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API } from "../config";

const Consultants = () => {
  const [consultants, setConsultants] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedSpecialty, setSelectedSpecialty] = useState('all');
  const [selectedCategory, setSelectedCategory] = useState('all');

  useEffect(() => {
    fetchConsultants();
  }, []);

  const fetchConsultants = async () => {
    try {
      const response = await axios.get(`${API}/consultants`);
      setConsultants(response.data);
    } catch (error) {
      console.error('Error fetching consultants:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleBooking = (consultantId) => {
    alert('Booking feature coming soon! (Mock implementation)');
  };

  // Filtering Logic
  const filteredConsultants = consultants.filter(c => {
    // Search Query match name or bio
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      const matchName = c.name.toLowerCase().includes(q);
      const matchBio = c.bio.toLowerCase().includes(q);
      if (!matchName && !matchBio) return false;
    }

    // Specialty filter match
    if (selectedSpecialty !== 'all') {
      const hasSpecialty = c.specializations.some(s => s.toLowerCase().includes(selectedSpecialty.toLowerCase()));
      if (!hasSpecialty) return false;
    }

    // Category Filter match
    if (selectedCategory !== 'all') {
      const hasCategory = c.specializations.some(s => s.toLowerCase().includes(selectedCategory.toLowerCase()));
      if (!hasCategory) return false;
    }

    return true;
  });

  return (
    <div className="min-h-screen pt-28 pb-20 bg-[#F9F6F0] relative overflow-hidden">
      {/* Background drifting blobs */}
      <div className="bg-blob blob-gold top-[10%] left-[-5%] w-[450px] h-[450px] opacity-40" />
      <div className="bg-blob blob-saffron bottom-[10%] right-[-5%] w-[500px] h-[500px] opacity-40" />

      <div className="container mx-auto max-w-5xl px-6 md:px-12 relative z-10">
        
        {/* Banner Section */}
        <div className="text-center mb-10">
          <span className="text-[10px] font-bold tracking-widest uppercase text-[#826239] mb-2 block">
            Vastu Vidya Wisdom
          </span>
          <h1 className="text-3xl md:text-5xl font-bold font-vedic text-[#352520] mb-6">
            Harmony is a <span className="text-[#D97706] italic font-normal">Precision Art</span>
          </h1>
        </div>

        {/* Search Panel */}
        <div className="max-w-4xl mx-auto mb-6 bg-white border border-[#EBE6DD] rounded-3xl p-4 shadow-md flex flex-col md:flex-row items-center gap-4">
          {/* Search by Name/City */}
          <div className="relative flex-grow w-full">
            <input
              type="text"
              placeholder="Search by name or city..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="w-full bg-[#F9F6F0]/50 border border-[#EBE6DD] rounded-2xl pl-12 pr-4 py-3.5 text-sm font-medium text-[#352520] placeholder-[#826239]/65 focus:outline-none focus:border-[#D97706]"
            />
            <svg className="w-5 h-5 text-[#826239]/60 absolute left-4 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>

          {/* Specialty Select Dropdown */}
          <div className="relative w-full md:w-64">
            <select
              value={selectedSpecialty}
              onChange={(e) => setSelectedSpecialty(e.target.value)}
              className="w-full bg-[#F9F6F0]/50 border border-[#EBE6DD] rounded-2xl pl-12 pr-8 py-3.5 text-sm font-semibold text-[#826239] focus:outline-none focus:border-[#D97706] appearance-none"
            >
              <option value="all">Specialty</option>
              <option value="Residential">Residential Vastu</option>
              <option value="Commercial">Commercial Spaces</option>
              <option value="Temple">Temple Architecture</option>
            </select>
            <svg className="w-5 h-5 text-[#826239]/60 absolute left-4 top-1/2 -translate-y-1/2" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <svg className="w-4 h-4 text-[#826239]/60 absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {/* Find Experts Button */}
          <button className="w-full md:w-auto bg-[#D97706] hover:bg-[#C25E03] text-white px-8 py-3.5 rounded-2xl text-sm font-bold transition-all whitespace-nowrap active:scale-97 flex items-center justify-center gap-2">
            Find Experts
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2.5" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
            </svg>
          </button>
        </div>

        {/* Category Pills */}
        <div className="flex flex-wrap gap-3 justify-center mb-16">
          {['Residential', 'Commercial', 'Industrial', 'Township'].map((cat) => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(selectedCategory === cat ? 'all' : cat)}
              className={`px-5 py-2 rounded-full text-xs font-semibold tracking-wide transition-all shadow-sm ${
                selectedCategory === cat
                  ? 'bg-[#826239] text-white border border-[#826239]'
                  : 'bg-white text-[#826239] border border-[#EBE6DD] hover:border-[#D97706]'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Acharyas Grid Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
          <div className="text-left">
            <h2 className="text-2xl font-bold font-vedic text-[#352520]">
              Vastu Acharyas
            </h2>
            <p className="text-xs text-[#5D4E37] font-light leading-relaxed">
              Verified master consultants selected for their architectural lineage and AI proficiency.
            </p>
          </div>
          <div className="text-sm font-semibold text-[#826239] cursor-pointer hover:text-[#D97706] transition-colors">
            Sort by: <span className="underline">Rating ▾</span>
          </div>
        </div>

        {/* Cards Stack */}
        {loading ? (
          <div className="text-center py-20">
            <div className="w-12 h-12 border-4 border-[#826239] border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-sm text-[#826239] font-medium">Loading consultants...</p>
          </div>
        ) : (
          <div className="flex flex-col gap-6 mb-12">
            {filteredConsultants.map((consultant) => (
              <div
                key={consultant.id}
                className="bg-white border border-[#EBE6DD]/60 rounded-3xl p-6 md:p-8 shadow-sm hover:shadow-md transition-all duration-300 flex flex-col md:flex-row gap-6 md:gap-8 items-start"
              >
                {/* Left Profile Photo */}
                <div className="flex-shrink-0 mx-auto md:mx-0">
                  <img
                    src={consultant.photo_url}
                    alt={consultant.name}
                    className="w-28 h-28 md:w-32 md:h-32 rounded-full object-cover border border-[#EBE6DD]"
                  />
                </div>

                {/* Right Info Section */}
                <div className="flex-grow w-full">
                  
                  {/* Name and Rating */}
                  <h3 className="text-xl md:text-2xl font-bold font-vedic text-[#352520] text-left mb-1.5">
                    {consultant.name}
                  </h3>
                  
                  <div className="flex items-center gap-2 mb-4 text-sm font-medium">
                    <svg className="w-4 h-4 text-[#D97706] fill-[#D97706]" viewBox="0 0 20 20">
                      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                    </svg>
                    <span className="text-[#352520] font-bold">{consultant.rating}</span>
                    <span className="text-[#826239]/70 font-light">({consultant.total_consultations} consultations)</span>
                  </div>

                  {/* Bio */}
                  <p className="text-sm text-[#5D4E37] leading-relaxed font-light mb-5 text-left">
                    {consultant.bio}
                  </p>

                  {/* Specializations inline list */}
                  <div className="mb-4 text-left">
                    <h4 className="text-xs font-bold text-[#352520] uppercase tracking-wider mb-1.5">Specializations:</h4>
                    <div className="flex flex-wrap gap-x-5 gap-y-1.5 text-xs text-[#826239] font-medium">
                      {consultant.specializations.map((spec, idx) => (
                        <span key={idx}>{spec}</span>
                      ))}
                    </div>
                  </div>

                  {/* Languages inline */}
                  <div className="mb-6 text-left">
                    <h4 className="text-xs font-bold text-[#352520] uppercase tracking-wider mb-1.5">Languages:</h4>
                    <p className="text-xs text-[#5D4E37] font-light">{consultant.languages.join(', ')}</p>
                  </div>

                  {/* Booking Action Row */}
                  <div className="flex flex-wrap gap-3">
                    {/* Chat Now Button */}
                    <button
                      onClick={() => handleBooking(consultant.id)}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-[#D97706] hover:bg-[#C25E03] text-white rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-300 shadow-md active:scale-97"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                      </svg>
                      Chat Now
                    </button>

                    {/* Book Video Call Button */}
                    <button
                      onClick={() => handleBooking(consultant.id)}
                      className="inline-flex items-center gap-2 px-6 py-3 bg-white border-2 border-[#D97706] hover:border-[#C25E03] text-[#D97706] hover:text-[#C25E03] rounded-full text-xs font-bold uppercase tracking-wider transition-all duration-300 active:scale-97"
                    >
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                      </svg>
                      Book Video Call
                    </button>
                  </div>

                </div>
              </div>
            ))}
          </div>
        )}        
      </div>
    </div>
  );
};

export default Consultants;
